export enum GATEWAYS {
    STRIPE = 'Stripe',
    PAYPAL = 'Paypal'
}

export const WALLET_TOP_UPS = [10, 20, 30, 50, 100, 130, 150, 200, 300, 500];

export const PAYMENT_CURRENCY = 'GBP';